module.exports = __webpack_public_path__ + "img/8E6767_D9C4C4_C8ACAC_B89898-256px.372a147a.png";